import KunLoading57 from './src/index'

KunLoading57.install = function (Vue) {
	Vue.component(KunLoading57.name, KunLoading57);
}

export default KunLoading57;
